<template>
  <div>
    <div class="container z-depth-2 hoverable" style="padding:25px; margin-top:15px; margin-bottom:15px">
      <div style="text-align:left" class="">
        <h4 class="grey-text text-darken-3">Managing Committie</h4>
        <div class="">
          <p>Managing committie is an anually elected body responsible to govern and manage the church.
          Together with the vicar they manage the day to day operations of church. The Managing Committee
          consists of a small body of elected officials to oversee the financial and other administrative
          matters concerning the Malankara Orthodox Church.</p>
        </div>
        <table class="highlight">
        <thead>
          <tr>
              <th>Sn.</th>
              <th>Position</th>
              <th>Name</th>
              <th>Contact</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Vicar/ Chairman</td>
            <td>Fr. Mathew Varghese</td>
            <td>frmathewadakal@yahoo.com</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Vice Chairman (Society)</td>
            <td>Mr. Shajan Pailo Paul</td>
            <td></td>
          </tr>
          <tr>
            <td>3</td>
            <td>Honorary Trustee (Chuch/Society)</td>
            <td>Mr. Salu Thomas</td>
            <td>salu.kollinal@gmail.com</td>
          </tr>
          <tr>
            <td>4</td>
            <td>Honorary Sectretary</td>
            <td>Mr. Yohannan K. C.</td>
            <td></td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Management"
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Management.vue